import { createComponent, EventName } from '@lit/react';
import React from 'react';
import { SDSTextField } from '../sds-textfield/sds-textfield';
import { SheriffEventName } from './types';

export const SDSTextFieldWrapper = createComponent({
	tagName: 'sds-textfield',
	elementClass: SDSTextField,
	react: React,
	events: {
		onInput: 'input' as SheriffEventName,
		onChange: 'input' as SheriffEventName,
		onSelect: 'select' as SheriffEventName,
		onFocus: 'focus' as SheriffEventName,
		onBlur: 'blur' as SheriffEventName,
		onKeyDown: 'keydown' as EventName<KeyboardEvent>,
	},
});
